var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-427.000000, -622.000000)",
    fill: "#4FA7DF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nearest-Supermarket",
    transform: "translate(20.000000, 622.800000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(407.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4,12.4 C15.5919076,12.4 15.7733448,12.3563785 15.9380064,12.2734151 C16.3413381,12.0701996 16.6,11.6588612 16.6,11.2 L16.6,3.2 C16.6,2.5372583 16.0627417,2 15.4,2 L8.2,2 C7.71763389,2 7.28835748,2.28659373 7.09869571,2.72137995 C7.03386375,2.87000265 7,3.03080103 7,3.2 L5,3.2 C5,2.74555648 5.09472958,2.31323824 5.2655194,1.92171464 C5.7589238,0.790619865 6.88713232,-1.15463195e-14 8.2,-1.15463195e-14 L15.4,-1.15463195e-14 C17.1673112,-1.15463195e-14 18.6,1.4326888 18.6,3.2 L18.6,11.2 C18.6,12.4501853 17.8830735,13.5329235 16.837919,14.0595162 C16.4056019,14.2773357 15.9171259,14.4 15.4,14.4 L15.4,12.4 Z M3.2,6 C2.5372583,6 2,6.5372583 2,7.2 L2,15.2 C2,15.8627417 2.5372583,16.4 3.2,16.4 L10.4,16.4 C11.0627417,16.4 11.6,15.8627417 11.6,15.2 L11.6,7.2 C11.6,6.5372583 11.0627417,6 10.4,6 L3.2,6 Z M3.2,4 L10.4,4 C12.1673112,4 13.6,5.4326888 13.6,7.2 L13.6,15.2 C13.6,16.9673112 12.1673112,18.4 10.4,18.4 L3.2,18.4 C1.4326888,18.4 -4.37483986e-14,16.9673112 -4.39648318e-14,15.2 L-4.4408921e-14,7.2 C-4.46253542e-14,5.4326888 1.4326888,4 3.2,4 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6197633fe6d7e6e6984d2a78d2d51e4e.svg";
export { ForwardRef as ReactComponent };